import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Card, Button, Form, ListGroup } from "react-bootstrap";
import { getUserSession } from "../component/userInfo";

const AdminBoardView = () => {
  const { postId } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const userSession = getUserSession();

  useEffect(() => {
    fetchPostAndComments();
  }, [postId]);

  const fetchPostAndComments = async () => {
    // Fetch Post
    const postFormData = new FormData();
    postFormData.append("action", "view");
    postFormData.append("post_id", postId);

    try {
      const postRes = await fetch(
        "https://work.wekoinonia.org/json/admin_board.php",
        {
          method: "POST",
          body: postFormData,
        }
      );
      const postData = await postRes.json();
      if (postData.success) {
        setPost(postData.post);
      } else {
        // alert(postData.message);
        // navigate('/adminboard'); // Redirect if post not found
        const mockPost = {
          post_id: postId,
          title: `게시글 ${postId} 제목`,
          content: `게시글 ${postId} 내용입니다.`,
          creator: "mock_admin_uid",
          idate: "2025-09-12 10:00:00",
          udate: "2025-09-12 10:00:00",
        };
        setPost(mockPost);
      }
    } catch (error) {
      console.error("Failed to fetch post:", error);
      // Mock data for UI development
      const mockPost = {
        post_id: postId,
        title: `게시글 ${postId} 제목`,
        content: `게시글 ${postId} 내용입니다.`,
        creator: "mock_admin_uid",
        idate: "2025-09-12 10:00:00",
        udate: "2025-09-12 10:00:00",
      };
      setPost(mockPost);
    }

    // Fetch Comments
    const commentsFormData = new FormData();
    commentsFormData.append("action", "list_comments");
    commentsFormData.append("post_id", postId);

    try {
      const commentsRes = await fetch(
        "https://work.wekoinonia.org/json/admin_board.php",
        {
          method: "POST",
          body: commentsFormData,
        }
      );
      const commentsData = await commentsRes.json();
      if (commentsData.success) {
        setComments(commentsData.comments);
      } else {
        // alert(commentsData.message);
        const mockComments = [
          {
            comment_id: 1,
            content: "첫 번째 댓글입니다.",
            creator: "mock_user_1",
            idate: "2025-09-12 10:05:00",
          },
          {
            comment_id: 2,
            content: "두 번째 댓글입니다.",
            creator: "mock_user_2",
            idate: "2025-09-12 10:10:00",
          },
        ];
        setComments(mockComments);
      }
    } catch (error) {
      console.error("Failed to fetch comments:", error);
      // Mock data for UI development
      const mockComments = [
        {
          comment_id: 1,
          content: "첫 번째 댓글입니다.",
          creator: "mock_user_1",
          idate: "2025-09-12 10:05:00",
        },
        {
          comment_id: 2,
          content: "두 번째 댓글입니다.",
          creator: "mock_user_2",
          idate: "2025-09-12 10:10:00",
        },
      ];
      setComments(mockComments);
    }
  };

  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    if (!newComment.trim()) {
      alert("댓글 내용을 입력해주세요.");
      return;
    }

    const formData = new FormData();
    formData.append("uid", userSession.uid);
    formData.append("action", "add_comment");
    formData.append("post_id", postId);
    formData.append("content", newComment);

    try {
      const res = await fetch(
        "https://work.wekoinonia.org/json/admin_board.php",
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await res.json();
      if (data.success) {
        setNewComment("");
        fetchPostAndComments(); // Refresh comments
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error("Failed to add comment:", error);
      alert("댓글 추가에 실패했습니다.");
    }
  };

  const handleDeleteComment = async (commentId) => {
    if (!window.confirm("정말로 이 댓글을 삭제하시겠습니까?")) {
      return;
    }

    const formData = new FormData();
    formData.append("uid", userSession.uid);
    formData.append("action", "delete_comment");
    formData.append("comment_id", commentId);

    try {
      const res = await fetch(
        "https://work.wekoinonia.org/json/admin_board.php",
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await res.json();
      if (data.success) {
        fetchPostAndComments(); // Refresh comments
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error("Failed to delete comment:", error);
      alert("댓글 삭제에 실패했습니다.");
    }
  };

  if (!post) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h1 className="h3 mb-2 text-gray-800">게시글 보기</h1>
      <Card className="shadow mb-4">
        <Card.Header as="h5">{post.title}</Card.Header>
        <Card.Body>
          <Card.Subtitle className="mb-2 text-muted">
            작성자: {post.creator_name}{" "}
            {/* Displays creator UID. For creator_name, backend needs to provide it. */}{" "}
            | 작성일: {post.idate}
          </Card.Subtitle>
          <Card.Text dangerouslySetInnerHTML={{ __html: post.content }} />
          <div className="d-flex justify-content-end">
            <Link to={`/adminboard/form/${post.post_id}`}>
              <Button variant="outline-secondary" className="me-2">
                수정
              </Button>
            </Link>
            <Button variant="secondary" onClick={() => navigate("/adminboard")}>
              목록으로
            </Button>
          </div>
        </Card.Body>
      </Card>

      <h3 className="mt-4">댓글</h3>
      <Card className="shadow mb-4">
        <Card.Body>
          {comments.length > 0 ? (
            <ListGroup variant="flush">
              {comments.map((comment) => (
                <ListGroup.Item key={comment.comment_id}>
                  <div className="d-flex justify-content-between">
                    <div>
                      <strong>{comment.creator_name}</strong>{" "}
                      {/* Displays creator UID. For creator_name, backend needs to provide it. */}{" "}
                      <small className="text-muted">{comment.idate}</small>
                      <p className="mb-0">{comment.content}</p>
                    </div>
                    {userSession &&
                      userSession.uid === comment.creator && ( // Only allow creator to delete their comment
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() =>
                            handleDeleteComment(comment.comment_id)
                          }
                        >
                          삭제
                        </Button>
                      )}
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          ) : (
            <p>댓글이 없습니다.</p>
          )}

          <Form onSubmit={handleCommentSubmit} className="mt-3">
            <Form.Group className="mb-3" controlId="formNewComment">
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="댓글을 입력하세요"
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                required
              />
            </Form.Group>
            <div className="d-flex justify-content-end">
              <Button variant="primary" type="submit">
                댓글 작성
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default AdminBoardView;
